import React from "react";

type PaginationProps = {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  ariaLabel?: string;
};

export const PaginationThemed: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
  ariaLabel = "Pagination" 
}) => {
  if (totalPages <= 1) return null;

  const handleClick = (page: number) => {
    if (page !== currentPage && page > 0 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const getPages = () => {
    const pages: (number | string)[] = [];
    const maxVisiblePages = 10;
    const sidePages = 3;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      const start = Math.max(2, currentPage - sidePages);
      const end = Math.min(totalPages - 1, currentPage + sidePages);

      pages.push(1);
      if (start > 2) pages.push("...");
      for (let i = start; i <= end; i++) pages.push(i);
      if (end < totalPages - 1) pages.push("...");
      pages.push(totalPages);
    }

    return pages;
  };

  return (
    <nav aria-label={ariaLabel}>
      <ul className="pagination">
        <li
          className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
          onClick={() => handleClick(currentPage - 1)}
        >
          <button className="page-link" aria-label="Previous">
            &laquo;
          </button>
        </li>
        {getPages().map((page, index) => (
          <li
            key={index}
            className={`page-item ${page === currentPage ? "active" : ""} ${typeof page === "string" ? "disabled" : ""}`}
            onClick={typeof page === "number" ? () => handleClick(page) : undefined}
          >
            <button className="page-link" disabled={typeof page === "string"}>
              {page}
            </button>
          </li>
        ))}
        <li
          className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
          onClick={() => handleClick(currentPage + 1)}
        >
          <button className="page-link" aria-label="Next">
            &raquo;
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default PaginationThemed;
